/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Panel_Invite_Codes_TitleInputs */



/**
* | output |
* | --- |
* | "Invite links" |
*
* @param {Panel_Invite_Codes_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const panel_invite_codes_title = /** @type {((inputs?: Panel_Invite_Codes_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Panel_Invite_Codes_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ссылки-приглашения")
	return /** @type {LocalizedString} */ ("Invite links")
});